/**
 * Công thức phân bổ chi khác
 * tvtoan 30/01/2023
 */
export default {
  CalculateSalary1: 5,
};
